export default __webpack_public_path__ + "static/media/checkbox-unchecked.228d0692.svg";